// The ordered list of calculators shown in the navigation switcher.
// Available calculators (registered in the registry) are clickable;
// others appear muted until their definition is added.
// `country` (optional) routes country-specific calculators to their
// country URL so locale and currency resolve correctly.
export const CALCULATOR_LINEUP = [
  { slug: "salary", name: "Salary", country: "US" },
  { slug: "mortgage", name: "Mortgage", country: "US" },
  { slug: "loan", name: "Loan", country: "US" },
  { slug: "compound-interest", name: "Compound Interest" },
];